import {
  jb_search_overlay_css_default
} from "./chunk.6ZDDQVLT.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  Animatable
} from "./chunk.27HF5Y4Z.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  e,
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-search-overlay/jb-search-overlay.ts
var JbSearchOverlay = class extends Initiable(Animatable(r)) {
  update(changedProperties) {
    super.update(changedProperties);
    if (changedProperties.has("formAction") && this.formAction && this._form) {
      const formActionUrl = new URL(this.formAction);
      formActionUrl.searchParams.forEach((value, key) => {
        const input = document.createElement("input");
        input.setAttribute("type", "hidden");
        input.setAttribute("name", key);
        input.setAttribute("value", value);
        this._form?.append(input);
      });
    }
  }
  firstUpdated(_changedProperties) {
    super.firstUpdated(_changedProperties);
    setTimeout(() => {
      this._searchInput?.focusSearchInput();
      document.dispatchEvent(new CustomEvent("jb-focus-fly:reset", { bubbles: true, composed: true }));
    }, 500);
  }
  _submit(event) {
    if (this._queryInput) {
      this._queryInput.value = event.detail.value;
    }
    this._form?.submit();
  }
  render() {
    const formActionUrl = new URL(this.formAction, document.baseURI);
    const action = `${formActionUrl.protocol}//${formActionUrl.host}${formActionUrl.pathname ? `${formActionUrl.pathname}` : ""}${formActionUrl.port ? `:${formActionUrl.port}` : ""} `;
    return ke`
      <section>
        <form
          method="get"
          action="${action}"
        >
          <input
            id="queryInput"
            type="hidden"
            name="${this.queryParameter}"
            value=""
          />
          <jb-search-input
            class="in-search-overlay"
            @jb-search-input:submit=${this._submit}
            .ariaLabels=${this.searchInput.ariaLabels ?? D}
            .autoSuggestUrl=${this.searchInput.autoSuggestUrl}
            .placeholder=${this.searchInput.placeholder}
            .suggestMode=${this.searchInput.suggestMode}
          ></jb-search-input>
        </form>
      </section>
    `;
  }
};
JbSearchOverlay.styles = [reset_css_default, jb_search_overlay_css_default];
__decorateClass([
  n()
], JbSearchOverlay.prototype, "formAction", 2);
__decorateClass([
  n()
], JbSearchOverlay.prototype, "queryParameter", 2);
__decorateClass([
  n({ type: Object })
], JbSearchOverlay.prototype, "searchInput", 2);
__decorateClass([
  e("form")
], JbSearchOverlay.prototype, "_form", 2);
__decorateClass([
  e("#queryInput")
], JbSearchOverlay.prototype, "_queryInput", 2);
__decorateClass([
  e("jb-search-input")
], JbSearchOverlay.prototype, "_searchInput", 2);
JbSearchOverlay = __decorateClass([
  customElement("jb-search-overlay")
], JbSearchOverlay);

export {
  JbSearchOverlay
};
